/* eslint-disable */
export const environment = {
  apiUrl: 'https://api-staging.swipesum.com/api',
  authUrl: 'https://api-staging.swipesum.com/api',
  gatewayUrl: 'https://gateway-staging.swipesum.com',
  setRoot: true,
  logLevel: 4,
  reportLogging: false,
  portalUrl: 'https://portal-staging.swipesum.com',
  suiteUrl: 'https://cpo-staging.swipesum.com',
  auditUrl: 'https://audit-staging.swipesum.com'
};
